import script from "./NotAuthorized.vue?vue&type=script&setup=true&lang=js"
export * from "./NotAuthorized.vue?vue&type=script&setup=true&lang=js"

import "./NotAuthorized.vue?vue&type=style&index=0&id=1023c892&lang=scss"

export default script